import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { BreadcrumbComponent, IBreadcrumbConfig, IBreadcrumbItem } from '@ra-web-tech-ui-toolkit/components';

@Component({
  selector: 'ra-fthub-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  imports: [BreadcrumbComponent],
})
export class SharedBreadcrumbComponent implements OnChanges {
  @Input() id = 'shared-breadcrumb';
  @Input() items: IBreadcrumbItem[] = [];
  @Input() title = '';
  @Input() config: IBreadcrumbConfig = { emptyText: '', hideTitle: false };
  @Input() isReadOnly = false;
  @Input() autoHideTitle = false;
  @Output() itemClicked = new EventEmitter<IBreadcrumbItem>();

  // derived once per input change (not on every change-detection pass) to keep a stable [config] reference
  resolvedConfig: IBreadcrumbConfig = this.config;

  ngOnChanges(): void {
    this.resolvedConfig = this.computeResolvedConfig();
  }

  private computeResolvedConfig(): IBreadcrumbConfig {
    if (!this.autoHideTitle) {
      return this.config;
    }

    const children = this.items[1]?.children;
    return {
      ...this.config,
      hideTitle: Array.isArray(children) && children.length > 0,
    };
  }
}
